<template>
  <div></div>
</template>

<script>
export default {
  name: "IdealoCookieSetter",
  props: {
    cookieName: {
      required: true,
      type: String,
    },
    paramName: {
      required: true,
      type: String,
    },
  },
  created() {
    if (this.getParam()) {
      this.setCookie();
    }
  },
  methods: {
    getParam() {
      return new URL(window.location.href).searchParams.get(this.paramName);
    },
    getExpirationDate() {
      return new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 30).toUTCString();
    },
    setCookie() {
      document.cookie = `${
        this.cookieName
      }=${this.getParam()};expires=${this.getExpirationDate()};path=/`;
    },
  },
};
</script>
